import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const baseUrl = process.env.REACT_APP_API_BASE_URL;
const token = sessionStorage.getItem("token");

export const getEc2Status = createAsyncThunk(
  "Ec2Status",
  async (args, { rejectWithValue }) => {
    try {
      const response = await fetch(`${baseUrl}/api/ec2`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization:
            `Bearer ${token}`,
        },
      });
      const result = await response.json(); // Await the result of response.json()
      return result;
    } catch (error) {
      return rejectWithValue("error.response");
    }
  }
);

export const updateEc2Status = createAsyncThunk(
  "updateEc2Status",
  async (args, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${baseUrl}/api/ec2/update-status`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              `Bearer ${token}`,
          },
        }
      );
      const result = await response.json(); // Await the result of response.json()
      return result;
    } catch (error) {
      return rejectWithValue("error.response");
    }
  }
);

export const signin = createAsyncThunk("signin", async ({email,password}, { rejectWithValue }) => {
  try {
    const response = await fetch(`${baseUrl}/api/admin/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({email, password}),
    });
    const result = await response.json(); // Await the result of response.json()
    return result;
  } catch (error) {
    return rejectWithValue("error.response");
  }
});

export const ec2Detail = createSlice({
  name: "ec2Detail",
  initialState: {
    status: "loading",
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEc2Status.pending, (state) => {
        state.loading = true;
      })
      .addCase(getEc2Status.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success == false) {
          state.status = "error";
        } else state.status = action.payload.data.status;
      })
      .addCase(getEc2Status.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.data;
      })

      .addCase(updateEc2Status.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateEc2Status.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success == false) {
          state.status = "error";
        } else state.status = action.payload.data.status;
      })
      .addCase(updateEc2Status.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.data;
      })

      .addCase(signin.pending, (state) => {
        state.loading = true;
      })
      .addCase(signin.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success == false) {
          state.status = "error";
        }else{
          sessionStorage.setItem("token", action.payload.data.accessToken);
          window.location.reload();
        }
      })
      .addCase(signin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.data;
      });
  },
});

export default ec2Detail.reducer;
